import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_PUP_BL: TStep[] = [
  {
    pageId: PageId.DOG_AGE_PUP_BL,
  },
  {
    pageId: PageId.DOG_OWNER_PUP_BL,
  },
  {
    pageId: PageId.TRAINING_COMMANDS_PUP_BL,
  },
  {
    pageId: PageId.URGE_PAGE_PUP_BL,
  },
  {
    pageId: PageId.DOG_BREED_PUP_BL,
  },
  {
    pageId: PageId.FACING_CHALLENGES_PUP_BL,
  },
  {
    pageId: PageId.FACING_CHALLENGES_2_PUP_BL,
  },
  {
    pageId: PageId.BEHAVIOR_FREQUENCY_PUP_BL,
  },
  {
    pageId: PageId.URGE_PROGRAM_PUP_BL,
  },
  {
    pageId: PageId.BEHAVIOR_FEELINGS_PUP_BL,
  },
  {
    pageId: PageId.FIX_BEHAVIOR_PUP_BL,
  },
  {
    pageId: PageId.URGE_PAGE_4_PUP_BL,
  },
  {
    pageId: PageId.PARENT_GOAL_PUP_BL,
  },
  {
    pageId: PageId.TRAINING_PLACE_PUP_BL,
  },
  {
    pageId: PageId.COMMANDS_PUP_BL,
  },
  {
    pageId: PageId.TRAINING_FREQUENCY_PUP_BL,
  },
  {
    pageId: PageId.URGE_PAGE_5_PUP_BL,
  },
  {
    pageId: PageId.PREPARE_FLOW_PUP_BL,
  },
  {
    pageId: PageId.EMAIL_PUP_BL,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_PUP_BL,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_PUP_BL,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_PUP_BL,
  },
  {
    pageId: PageId.CHAT_UPSELL_PUP_BL,
  },
  {
    pageId: PageId.UPSELL_PUP_BL,
  },
  {
    pageId: PageId.UPSELL_FEEDING_GUIDE_PUP_BL,
  },
  {
    pageId: PageId.UPSELL_EMOTIONAL_SUPPORT_PUP_BL,
  },
  {
    pageId: PageId.DOWNLOAD_PUP_BL,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PUP_BL.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PUP_BL.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS_TEST_B = [
  PageId.FACING_CHALLENGES_PUP_BL,
  PageId.FACING_CHALLENGES_2_PUP_BL,
  PageId.DOG_BREED_PUP_BL,
  PageId.BEHAVIOR_FEELINGS_PUP_BL,
  PageId.FIX_BEHAVIOR_PUP_BL,
  PageId.PARENT_GOAL_PUP_BL,
  PageId.TRAINING_PLACE_PUP_BL,
  PageId.TRAINING_FREQUENCY_PUP_BL,
]

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS_TEST_B = [
  PageId.FACING_CHALLENGES_PUP_BL,
  PageId.FACING_CHALLENGES_2_PUP_BL,
  PageId.DOG_BREED_PUP_BL,
  PageId.BEHAVIOR_FEELINGS_PUP_BL,
  PageId.FIX_BEHAVIOR_PUP_BL,
  PageId.PARENT_GOAL_PUP_BL,
  PageId.TRAINING_PLACE_PUP_BL,
  PageId.TRAINING_FREQUENCY_PUP_BL,
]
